import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import getClientConfig from '../config';
import { RADIUS_TOKEN_KEY } from '../utils/radiusAuth';
import { radiusLogin } from '../utils/radiusApi';

const RadiusLogin = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  // ensure we use your config getter (you don't actually need the URL here,
  // but calling it keeps behavior consistent / future-proof)
  const { API_BASE_URL } = getClientConfig(); // eslint-disable-line no-unused-vars

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      const data = await radiusLogin({ username, password });
      if (!data?.token) throw new Error('No token in response');

      localStorage.setItem(RADIUS_TOKEN_KEY, data.token);
      if (data.user) localStorage.setItem('radius_user', JSON.stringify(data.user));
      if (data.user_type) localStorage.setItem('radius_user_type', data.user_type);
      if (data.permissions) localStorage.setItem('radius_permissions', JSON.stringify(data.permissions));

      navigate('/radius/dashboard');
    } catch (err) {
      setError(err.message || 'Login error');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md bg-white shadow-md rounded-lg p-6">
        <h1 className="text-2xl font-semibold text-gray-800 mb-1">Radius Login</h1>
        <p className="text-sm text-gray-500 mb-6">Sign in with your Radius credentials.</p>

        {error ? (
          <div className="mb-4 rounded-md border border-red-200 bg-red-50 p-3 text-red-700 text-sm">{error}</div>
        ) : null}

        <form onSubmit={handleSubmit} className="space-y-4">
          <label className="block">
            <span className="text-sm text-gray-700">Username</span>
            <input
              type="text"
              className="mt-1 w-full rounded-md border border-gray-300 px-3 py-2 text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-500"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="jdoe"
              autoFocus
              required
            />
          </label>

          <label className="block">
            <span className="text-sm text-gray-700">Password</span>
            <input
              type="password"
              className="mt-1 w-full rounded-md border border-gray-300 px-3 py-2 text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-500"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </label>

          <button
            type="submit"
            disabled={submitting}
            className="w-full rounded-md bg-indigo-600 px-4 py-2 font-medium text-white hover:bg-indigo-700 disabled:opacity-70"
          >
            {submitting ? 'Signing in…' : 'Sign In'}
          </button>
        </form>

        <div className="mt-6 text-sm text-gray-600">
          Are you a SysAdmin?{' '}
          <Link to="/sysadmin/login" className="text-indigo-600 hover:text-indigo-700 font-medium">
            Go to SysAdmin login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default RadiusLogin;
